module.exports = function getResource(label, vars = []) {
    const resources = {
        editProfile: 'Modifier le profil',
        profileCategories: [
            'Photos et description',
            'Peau',
            'Cheveux',
            'Yeux',
            'Color IQ',
            'Date de naissance',
            'Confidentialité'
        ]
    };
    return resources[label];
};
